<template>
  <section class="section" id="latest">
    <div class="section-heading is-half">
      <h2 class="title is-2 is-uppercase">Latest Work</h2>
    </div>
    <div class="column is-10 is-offset-1">
      <div class="columns is-full-height">
        <div class="column">
          <div class="card is-borderless is-paddingless">
            <div class="card-content is-paddingless">
              <div class="content is-size-4 is-size-5-mobile has-text-left-mobile has-text-justified">
                <p>
                  PatientPal is solution where clinicians can manage and schedule appointments, and patients can fill intake forms,
                  pay insurance and get doctor visit details. We built solution on Serverless (AWS + DynamoDB) for high availability,
                  performance and scaling. With Angular7 we built dynamic form generator where each clinic builds own intake flow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-full-height">
        <div class="column" v-for="latestWorkImage in latestWorkImages" :key="latestWorkImage.alt">
          <div class="card is-borderless">
            <div class="card-image">
              <figure class="image" data-aos="zoom-in" data-aos-easing="ease-out-back">
                <picture>
                  <source :srcset="latestWorkImage.newImageFormat" type="image/webp">
                  <img :src="latestWorkImage.traditionalImageFormat" :alt="latestWorkImage.alt">
                </picture>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'LatestWorkPage',
  data () {
    return {
      latestWorkImages: [
        {
          traditionalImageFormat: require('@/assets/images/pp-tablet.jpg'),
          newImageFormat: require('@/assets/images/pp-tablet.webp'),
          alt: 'PatientPal tablet',
        },
        {
          traditionalImageFormat: require('@/assets/images/pp-profile.png'),
          newImageFormat: require('@/assets/images/pp-profile.webp'),
          alt: 'PatientPal profile',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~bulma";

.section-heading {
  text-align: center;
  margin: 5em 0;
  @include mobile {
    margin: 3em 0;
  }
}

.is-borderless {
  box-shadow: none;
}

.is-full-height {
  height: 100%;
}

h2.title {
  font-weight: 600;
  letter-spacing: 5px;
  line-height: 50px;
  text-transform: uppercase;
  &.has-text-white {
    font-weight: 400;
  }
}

.content {
  h3.title.is-4 {
    letter-spacing: 2px;
  }
  h4 {
    letter-spacing: 0.8px;
  }
}
</style>
